import baseConfig, { Config } from "../../utils/config";

// Visual query demo - Snowflake inspired by demo1
const snowflakeConfig: Config = {
  ...baseConfig,
  AppName: "CADViewer Visual Query:",
  initFileName: "",
  ServerBackEndUrl: "http://localhost:3000",
  ServerLocation: "",
  ServerUrl: "http://localhost:3001",
  DisplayCoordinatesMenu: false,
  displayTopNavigationBar: false,
  setSpaceObjectsCustomMenu: false,
  hideLeftHamburgerMenu: false,
  BaseAttributes: {
    fill: "#ffd7f4",
    "fill-opacity": 0.0,
    stroke: "#CCC",
    "stroke-width": 0.1,
    "stroke-linejoin": "round",
    "stroke-opacity": 1.0,
  },
  HighlightAttributes: {
    fill: "#a4d7f4",
    "fill-opacity": 0.5,
    stroke: "#a4d7f4",
    "stroke-width": 0.2,
    "stroke-linejoin": "round",
    "stroke-opacity": 1.0,
  },
  SelectAttributes: {
    fill: "#5BBEF6",
    "fill-opacity": 0.5,
    stroke: "#5BBEF6",
    "stroke-width": 0.23,
    "stroke-linejoin": "round",
    "stroke-opacity": 1.0,
  },
  postFixServerToken: false,
  // Locations for property data (same pattern as demo1, adapt for Snowflake-backed dataset gateway)
  globalApplicationFilesLocation:
    "http://localhost:3000/content/custom/realcomm_presentation/json/application/",
  propertySVGFilesLocation:
    "http://localhost:3000/content/custom/realcomm_presentation/svg/",
  propertyJSONFilesLocation:
    "http://localhost:3000/content/custom/realcomm_presentation/json/property/",
  // Default property to Load
  defautlPropertyToLoad: {
    propertyNumber: "4279",
    planName: "LP1",
  },
  enableQuickPdfPrint: true,
  pdfOrientationLabel: "Orientation",
  pdfOrientationPortraitLabel: "Portrait",
  pdfOrientationLandscapeLabel: "Landscape",
  pdfDefaultOrientation: "landscape" as "portrait" | "landscape",

  enableAIChat: true,
  useAIChatV5: true,
  useAIChatV4: false,
  chatResultDisplayMetrics: true,
  aiChatV5Endpoint: "http://localhost:3000/ai/proxy",
  aiChatV5Provider: "snowflake-agent" as
    | "snowflake"
    | "python"
    | "snowflake-agent",
  aiChatV5Mode: "Test" as "Test" | "Prod",
  propertyJSONFilesEnableDistance: true,
  propertyJSONFilesEnableLayerColors: true,
  topPaneScrollDownTitle: "Choose information plan/layer:",
  displayTopPaneScrollDownButton: true,
  topRowItem1: "Property Name:",
  topRowItem2: "Property Number:",
  topRowItem3: "Plan Name:",
  enableRightJSONModalPanel: true,
  enableRightFileModalPanel: false,
  setCADViewerSkin: "light-skin",
  setBPLayerChange: true,
  serverSubFolder: "/drawings/dwg/",
  showOnlySubFolder: true,
  showLogoOnSideBarLeftPanel: true,
  cvjs_styleQTip_width: "320px",

  enableHelperMethods: true,
  enableHelpersMethodsGroup_Highlight: false,
  enableHelpersMethodsGroup_Group: false,
  enableHelpersMethodsGroup_Manipulate: false,
  enableHelpersMethodsGroup_Insert: false,
  enableHelpersMethodsGroup_CustomCanvas: false,
  enableHelpersMethodsGroup_SpaceArea: false,
  enableHelpersMethodsGroup_RedlineArea: false,
  enableHelpersMethodsGroup_VizQueryDemo: false,
  enableHelpersMethodsGroup_Brookfield: true,
  enableHelpersMethodsGroup_UrbanEdge: false,
  enableHelpersMethodsGroup_UicEdu: false,
  enableHelpersMethodsGroup_Insuremep: false,
  omitSpaceObjectLayerHandling: false,


// VISUAL QUERY PANEL CONTROLS
  ShowInformativeBottomPanel: true, // turn the the bottom panel on off
  ShowInformativeBottomPanelWhenClickInLeftPanel: true,
  ShowInformativeLeftPanel: false, // initia show the left side panel
  bottomPaneSliderMode: "aboveCADViewer", // withCADViewer, aboveCADViewer,
  bottomPaneDefaultHeight: 15, // (15)   percentage of screen height (2) min
  rightPanelDefaultWidth: 36, // (40) percentage of screen height
  leftPaneDefaultWidth: 17, // (17) percentage of screen height


};

export default snowflakeConfig;
